import React from "react";
import Footer from "../footer/Footer";
import VTUserBuyVTHistory from "../page/VTUserBuyVTHistory";
import Header from "../header/Header";

export default function LandingUserBuyVTHistory() {
    return (
        <>
            <Header headerType="UserOnly"/>
            <VTUserBuyVTHistory/>
            <Footer/>
        </>
    );
}